export const appConfig = {
  environment: "dev",
  sendGridApiKey:
    "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",
  API: {
    URL: "https://api-qa.atyabtabkha.com",
    KEY: "c21f3a7d-d1d6-4a2c-bdc3-c609e14c75d9",
  },
  firebaseConfig: {
    apiKey: "AIzaSyC29kBCIiGhgwfRqhJbb6JRHqjECHLrPiM",
    authDomain: "webedia-arabia-qa.firebaseapp.com",
    projectId: "webedia-arabia-qa",
    storageBucket: "webedia-arabia-qa.appspot.com",
    messagingSenderId: "492434373462",
    appId: "1:492434373462:web:1da090d3540090a166b4f7",
    measurementId: "G-CB5RP9KCKQ",
  },
  appCheckKey: "6LeLWOUqAAAAAExH4YuRwXL6y_39Pm3yF-12M98W",
};
